<template lang="pug">
  .promotional-messages(v-if="showPromotionalMessages")
    p.xs-f-small.lg-f-medium.max-at-tweak(v-for="message in promotionalMessages" v-html="message")

</template>

<script>
  import { mapState } from "vuex";
  import vueCartSvc from "@services/vueCartSvc";

  export default {
    name: "PromotionalMessages",

    data() {
      return {
        promotionalMessages: null,
      };
    },

    computed: {
      ...mapState('pdp', ['product']),

      showPromotionalMessages() {
        return Boolean(this.promotionalMessages && this.promotionalMessages.length);
      }
    },

    watch: {
      product: {
        async handler() {
          const res = await vueCartSvc.getPromotionalMessagesByProductInfo({
            productId: this.product.id,
            productType: this.product.product_type,
            productCode: this.product.code
          });
          this.promotionalMessages = res.data;
        },
        immediate: true,
        deep: true,
      }
    },
  };
</script>

<style scoped lang="stylus">
  .promotional-messages
    margin 0.75em 0
    padding 0.5em
    background-color #f7f7f8
    color brand-color-1

</style>
